import React from "react";

const StaticContent = ({ description }) => {
  return (
    <>
      <p
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </>
  );
};

export default StaticContent;
